import React, { useState, useEffect } from "react";
import ProjectImg1 from "../assets/img/images/powerbi.webp";
import Image2 from "../assets/img/images/img6.jpg";
import Image3 from "../assets/img/images/pb.png";

const Powerbi = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    container: {
      fontFamily: "'Poppins', sans-serif",
    },
    contentWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      borderRadius: "10px",
      overflow: "hidden",
      backgroundColor: "#f9fafb",
      padding: "3rem 0",
     
    },
    section: {
      width: "100%",
       maxWidth:"80%",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      marginBottom: "30px",
      padding: "0 40px",
      alignItems: "center",
    },
    reverseSection: {
      maxWidth:"80%",   
         display: "flex",
      flexDirection: isMobile ? "column" : "row-reverse",
      justifyContent: "space-between",
      marginBottom: "30px",
      padding: "0 40px",
      alignItems: "center",
    },
    imageContainer: {
      flex: "1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      maxWidth:"80%",
    },
    image: {
      width: "100%",
      maxWidth: "400px",
      height: "auto",
      objectFit: "cover",
      borderRadius: "10px",
      transition: "transform 0.3s ease",
    },
    content: {
      flex: "1.5",
      color: "#333",
      textAlign: "justify",
      width: "100%",
      maxWidth:"80%",
    },
    heading: {
      fontWeight: "bold",
      marginBottom: "20px",
      marginTop: "4rem",
      color: "#7620ff",
      textAlign: "center",
    },
    subheading: {
      marginBottom: "15px",
      color: "#fdba00",
      fontWeight: "bold",
    },
    paragraph: {
      lineHeight: "1.6",
      color: "#555",
      marginBottom: "15px",
    },
    list: {
      paddingLeft: "20px",
      color: "#555",
      marginBottom: "20px",
    },
    listItem: {
      marginBottom: "10px",
    },
    card: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      marginBottom: "30px",
      transition: "transform 0.3s ease",
      width: "80%",
    },
    cardTitle: {
      fontWeight: "bold",
      color: "#fdba00",
      marginBottom: "10px",
    },
    cardList: {
      paddingLeft: "20px",
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <h1 style={styles.heading}>Microsoft Power BI</h1>

        {/* Section 1: Image Left, Content Right */}
        <div style={styles.section}>
          <div style={styles.imageContainer}>
            <img src={ProjectImg1} alt="Power BI" style={styles.image} />
          </div>
          <div style={styles.content}>
            <p style={styles.paragraph}>
              Microsoft Power BI is a business intelligence (BI) software platform that helps users visualize and analyze data from various sources. It allows users to connect to different data sources, create interactive reports and dashboards, and share insights with others. Power BI is designed to be user-friendly, even for those without extensive technical expertise, making it a popular choice for businesses and organizations.
            </p>
          </div>
        </div>

        {/* Section 2: Image Right, Content Left */}
        <div style={styles.reverseSection}>
          <div style={styles.imageContainer}>
            <img src={Image2} alt="Data Visualization" style={styles.image} />
          </div>
          <div style={styles.content}>
            <p style={styles.paragraph}>
              Power BI connects seamlessly to various data sources, making it easy to import data for analysis.
            </p>
            <p style={styles.paragraph}>
              Visualize your data in various formats such as charts, graphs, and maps for better decision-making.
            </p>
            <p style={styles.paragraph}>
              Power BI Mobile lets you access reports and dashboards from your mobile device for on-the-go decision-making.
            </p>
          </div>
        </div>

        {/* Section 3: Key Features */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Key Features and Benefits</h3>
          <ul style={styles.cardList}>
            <li style={styles.listItem}><strong>Data Connectivity:</strong> Power BI can connect to a wide range of data sources, including on-premises databases, cloud services, Excel files, and more.</li>
            <li style={styles.listItem}><strong>Data Visualization:</strong> It offers a variety of interactive charts, graphs, and maps to visualize data in meaningful ways.</li>
            <li style={styles.listItem}><strong>Report and Dashboard Creation:</strong> Users can build interactive reports and dashboards with drag-and-drop functionality and a wide range of visuals.</li>
            <li style={styles.listItem}><strong>Data Modeling and Analysis:</strong> Power BI supports data modeling, analysis, and the creation of custom calculations and measures.</li>
            <li style={styles.listItem}><strong>AI-Powered Insights:</strong> It incorporates AI capabilities to help users discover patterns and trends in their data.</li>
            <li style={styles.listItem}><strong>Sharing and Collaboration:</strong> Users can share reports and dashboards with others through the Power BI service, enabling collaboration and data-driven decision-making.</li>
            <li style={styles.listItem}><strong>Mobile Access:</strong> Power BI offers mobile apps for viewing reports and dashboards on the go.</li>
            <li style={styles.listItem}><strong>Scalability:</strong> Power BI can handle large datasets and can be scaled to support a wide range of users and organizations.</li>
            <li style={styles.listItem}><strong>Integration with Other Microsoft Products:</strong> It integrates seamlessly with other Microsoft products like Excel, Teams, and Power Platform, making it a versatile tool within the Microsoft ecosystem.</li>
          </ul>
        </div>

        {/* Section 4: Versions and Editions */}
        <div style={styles.reverseSection}>
          <div style={styles.imageContainer}>
            <img src={Image3} alt="Different Versions" style={styles.image} />
          </div>
          <div style={styles.content}>
            <h2 style={styles.subheading}>Different Versions and Editions</h2>
            <ul style={styles.list}>
              <li style={styles.listItem}><strong>Power BI Desktop:</strong> A free application for creating reports and connecting to data sources.</li>
              <li style={styles.listItem}><strong>Power BI Service:</strong> The cloud-based service for publishing, sharing, and managing reports.</li>
              <li style={styles.listItem}><strong>Power BI Mobile:</strong> Apps for viewing reports and dashboards on mobile devices.</li>
              <li style={styles.listItem}><strong>Power BI Report Server:</strong> A version for organizations that want to keep their data on-premises.</li>
            </ul>
            <p style={styles.paragraph}>
              In essence, Power BI is a powerful and versatile business intelligence platform that empowers users to explore, visualize, and share data for better decision-making.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Powerbi;
